export default __webpack_public_path__ + "static/media/033-forklift.84a73cc7.svg";